'use client'

import { useEffect, useState } from 'react'

/**
 * Reports whether the component has hydrated on the client.
 *
 * USE CASE:
 * Gating client-only values (e.g. breakpoint checks) so the first client render
 * matches the server render and avoids React hydration mismatches. Returns
 * `false` during SSR and the initial client render, then flips to `true` after
 * mount.
 */

export const useIsHydrated = (): boolean => {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => setIsHydrated(true), [])

  return isHydrated
}
